module.exports = __webpack_public_path__ + "1d8c13be0f976d417b8fa3cfff30351f.pdf";